let handler = function proxyHandler(observer) {
  return {
    get: function getter(target, key) {
      if (key === "isProxy") return true;

      const prop = target[key];

      // return if property not found
      if (typeof prop == "undefined" || prop === null) return prop;

      // set value as proxy if object
      if (!prop.isProxy && typeof prop === "object")
        target[key] = new Proxy(prop, handler(observer));

      return target[key];
    },
    set: function setter(...args) {
      const success = Reflect.set(...args);
      observer.notify(...args);
      return success;
    },
    deleteProperty: function deleteProp(target, property, value) {
      if (!(property in target)) {
        return false;
      }
      Reflect.deleteProperty(target, property);
      observer.notify(target, property, value);
      return true;
    }
  };
};

export function observeObject(obj, observer) {
  return new Proxy(obj, handler(observer));
}
